/**
 * `<Card>` — a surface panel (Keyline: 1px border, radius 4px, no shadow). Pure layout:
 * a vertical stack you compose from the part classes, which are the class contract:
 *
 *   <Card>
 *     <img class="weave-card__media" src="…" alt="…" />
 *     <h3 class="weave-card__title">Title</h3>
 *     <p class="weave-card__body">Body text.</p>
 *     <p class="weave-card__meta">Secondary meta.</p>
 *     <div class="weave-card__actions">
 *       <Button variant={{ 'marked' }}>Open</Button>
 *       <Button variant={{ 'ghost' }}>Dismiss</Button>
 *     </div>
 *   </Card>
 *
 * No behavior beyond forwarding `class`. `interactive` adds a hover tint — to make the
 * card actually clickable + accessible, wrap its content (or the card) in a link/button.
 */

export interface CardProps {
  /** Add a hover tint (for cards that act as a link/button). */
  interactive?: boolean;
  /** Extra classes, forwarded onto the container. */
  class?: string;
}

                                                                                   

export interface CardContext {
  cardClass: () => string;
}

export function setup(props: CardProps): CardContext {
  return {
    cardClass: (): string => {
      const parts: string[] = ['weave-card'];
      if (props.interactive) parts.push('weave-card--interactive');
      if (props.class) parts.push(props.class);
      return parts.join(' ');
    },
  };
}

import { defineComponent } from "@weave-framework/runtime/dom";

import { bindAttr, child, clone, mountChild, template } from "@weave-framework/runtime/dom";

const _t0 = template("<div data-w-nihbj3><!----><\/div>");
function render(ctx, slots) {
  const _r = clone(_t0);
  const _n0 = child(_r, 0);
  bindAttr(_r, "class", () => (ctx.cardClass()));
  { const _sf = slots["default"]; mountChild(_n0, _sf ? _sf() : null); }
  return _r;
}

export default defineComponent(render, setup);